import React from "react";
import values from "../../values";
import Context from "../../context";
import Components from "./Components";

import {
  BreadCrumb,
  CustomView,
  Pagination,
  TableHeader,
  TableLoading,
} from "../../components";

import "./index.sass";
import Cookies from "js-cookie";
import constants from "../../values/constants";
import { t } from "i18next";

type Props = {
  rqSchool: any;
};

const SchoolScreen = (props: Props) => {
  const { data, status } = props.rqSchool;
  const { allSchoolInfo, setAllSchoolInfo, requestSchool, setRequestSchool } =
    React.useContext(Context.SchoolScreen);

  const writePermission = Cookies.get(
    constants.USER.WRITE_PERMISSION
  )?.toString();

  return (
    <CustomView.Container id="school-screen-container">
      <CustomView.Row className="table-options-wrapper">
        <CustomView.Column
          extraLarge={3}
          large={5}
          medium={5}
          className="bread-crumb-wrapper"
        >
          <BreadCrumb />
        </CustomView.Column>
        <CustomView.Column
          extraLarge={4}
          large={5}
          medium={7}
          className="search-and-filter-wrapper"
        >
          {writePermission === "true" && <Components.Create />}
          <Components.Filter />
          <Components.Search />
        </CustomView.Column>
      </CustomView.Row>
      <div className="table-content-wrapper">
        <table>
          <TableHeader
            headers={values.tableHeaders.SCHOOL_HEADERS.map((item) => t(item))}
          />
          {status === "loading" ? (
            <TableLoading />
          ) : (
            <Components.Body data={data?.result?.docs} />
          )}
        </table>
      </div>
      {status === "success" &&
        data?.result?.totalDocs >
          values.constants.PANEL_TABLE_DEFAULT_LIMIT && (
          <div className="pagination">
            <Pagination
              page={requestSchool?.page}
              totalPages={data?.result?.totalPages}
              onPaginate={(page: number) =>
                setRequestSchool({ ...requestSchool, page })
              }
            />
          </div>
        )}
      {writePermission === "true" && <Components.Update />}
      <Components.ShowInformation />
    </CustomView.Container>
  );
};

export default SchoolScreen;
